"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilService = void 0;
var UtilService = /** @class */ (function () {
    function UtilService() {
    }
    UtilService.newUUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
            var // tslint:disable-next-line:no-bitwise
            randomNumber = (Math.random() * 16) | 0, newChar = char === 'x'
                ? randomNumber
                : // tslint:disable-next-line:no-bitwise
                    (randomNumber & 0x3) | 0x8;
            return newChar.toString(16);
        });
    };
    UtilService.getElementWidthWithoutPaddings = function (element) {
        if (!element)
            return;
        var elementWidth = element.getBoundingClientRect().width;
        var leftPadding = window.getComputedStyle(element, null).getPropertyValue('padding-left');
        var rightPadding = window.getComputedStyle(element, null).getPropertyValue('padding-right');
        return elementWidth - parseInt(leftPadding, 10) - parseInt(rightPadding, 10);
    };
    UtilService.getOffsetHeight = function (contextElement, selector) {
        var element = contextElement.querySelector(selector);
        return element ? element.offsetHeight : 0;
    };
    UtilService.getCSSValue = function (element, cssRule) {
        var elStyles = getComputedStyle(element);
        var cssRuleValueStr = elStyles.getPropertyValue(cssRule);
        return parseFloat(cssRuleValueStr) || 0;
    };
    UtilService.getCookieCategoriesAcceptance = function () {
        var CookieInformation = window['CookieInformation'];
        var functionalCookiesCategory = 'cookie_cat_functional';
        var marketingCookiesCategory = 'cookie_cat_marketing';
        var statisticCookiesCategory = 'cookie_cat_statistic';
        if (!CookieInformation || !CookieInformation.getConsentGivenFor)
            return;
        return {
            functional: CookieInformation.getConsentGivenFor(functionalCookiesCategory),
            marketing: CookieInformation.getConsentGivenFor(marketingCookiesCategory),
            statistic: CookieInformation.getConsentGivenFor(statisticCookiesCategory),
        };
    };
    UtilService.setAttributes = function (el, attrs) {
        for (var key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    };
    UtilService.generateUniqueID = function (quantity) {
        var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789';
        var result = '';
        for (var i = 0; i < quantity; i++) {
            var randomIndex = Math.floor(Math.random() * letters.length);
            result += letters.charAt(randomIndex);
        }
        return result;
    };
    UtilService.isArraysAreEqual = function (arr1, arr2) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (var i = 0; i < arr1.length; i++) {
            var item1 = arr1[i];
            var item2 = arr2[i];
            if (Array.isArray(item1) && Array.isArray(item2)) {
                if (!this.isArraysAreEqual(item1, item2)) {
                    return false;
                }
            }
            else if (typeof item1 === 'object' && typeof item2 === 'object') {
                if (!this.isObjectsAreEqual(item1, item2)) {
                    return false;
                }
            }
            else if (item1 !== item2) {
                return false;
            }
        }
        return true;
    };
    UtilService.isObjectsAreEqual = function (obj1, obj2) {
        var keys1 = Object.keys(obj1);
        var keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        for (var _i = 0, keys1_1 = keys1; _i < keys1_1.length; _i++) {
            var key = keys1_1[_i];
            var val1 = obj1[key];
            var val2 = obj2[key];
            if (Array.isArray(val1) && Array.isArray(val2)) {
                if (!this.isArraysAreEqual(val1, val2)) {
                    return false;
                }
            }
            else if (typeof val1 === 'object' && typeof val2 === 'object') {
                if (!this.isObjectsAreEqual(val1, val2)) {
                    return false;
                }
            }
            else if (val1 !== val2) {
                return false;
            }
        }
        return true;
    };
    UtilService.getCookie = function (cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    };
    // From : https://dev.to/ycmjason/javascript-fetch-retry-upon-failure-3p6g
    UtilService.PromiseRetryPolicy = function (func, n) {
        return func().catch(function (error) {
            if (n === 1) {
                throw error;
            }
            return UtilService.PromiseRetryPolicy(func, n - 1);
        });
    };
    UtilService.parseLanguageCode = function (culture) {
        var languageCode = 'en';
        if (culture) {
            languageCode = culture.indexOf('-') ? culture.split('-')[0] : culture;
        }
        return languageCode;
    };
    UtilService.globalCountry = 'global_country';
    UtilService.parseCountryCode = function (culture) {
        if (culture && culture.indexOf('-') !== -1) {
            return culture.split('-')[1];
        }
        return UtilService.globalCountry;
    };
    return UtilService;
}());
exports.UtilService = UtilService;
